import React from 'react';
import { toast } from 'sonner';
import { 
  Fire,
  CheckCircle,
  Exam,
  Trophy,
  Star,
  Medal
} from '@phosphor-icons/react';

const ICON_MAP = {
  fire: Fire,
  check: CheckCircle,
  exam: Exam,
  trophy: Trophy,
  star: Star,
};

export const showBadgeToast = (badge) => {
  const Icon = ICON_MAP[badge.icon] || Medal;
  toast.custom(() => (
    <div className="flex items-center gap-3 bg-card border border-accent/50 rounded-sm p-4 shadow-lg min-w-[280px]">
      <div className="w-10 h-10 rounded-sm bg-accent/20 flex items-center justify-center flex-shrink-0">
        <Icon weight="fill" className="w-6 h-6 text-accent" />
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-wider text-accent">Badge Earned!</p>
        <p className="font-heading font-bold text-sm">{badge.name}</p>
        <p className="text-xs text-muted-foreground">{badge.description}</p>
      </div>
    </div>
  ), { duration: 4000 });
};

export const showNewBadges = (badges) => {
  if (!badges || badges.length === 0) return;
  badges.forEach((badge, i) => {
    setTimeout(() => showBadgeToast(badge), i * 600);
  });
};
